async function addAvailabilityCheck () {
  if (window.theme.settings.template !== 'product.supadu') return
  // If no product price due to data issues, no need to show any stock message
  if (!window.theme.productData.price) return
  try {
    const productFormInner = document.querySelector('.product-form__inner')
    if (!productFormInner) return
    const { id } = window.theme.productData
    if (!id) return
    const item = window.theme.staticProductData
    if (!item) return
    const { isbn13 } = item
    const requestUrl = `https://add-to-cart.supadu.com/add-to-cart?action=availability&isbn=${isbn13}&client=1517-publishing`
    const response = await fetch(requestUrl)
    const responseJSON = await response.json()
    if (responseJSON.msg) {
      const { msg, show, preorder } = responseJSON
      const stockMessage = `
        <div class="availability-stock-message">
          <span>
            <strong>${msg}</strong>
          </span>
        </div>
      `
      productFormInner.insertAdjacentHTML('afterend', stockMessage)
      if (!show) {
        productFormInner.style.display = 'none'
      }
      if (preorder) {
        const buyForm = document.querySelector('.js-product-single__form')
        buyForm.style.display = 'block'
        const addToCart = buyForm.querySelector('.add-to-cart')
        addToCart.innerHTML = `<span id="AddToCartText-${id}">Pre-order</span>`
      }
    }
  } catch (e) {
    // console.log(e)
  }
}

// Remove Buy Section
function hideAudioBooks () {
  if (window.theme.settings.template !== 'product.supadu') return
  const buyButtonSection = document.querySelector('.js-product-form__switch-format')
  const item = window.theme.productData
  if (!item) return
  const format = item.type
  if (!format) return

  if (format === 'eAudio') {
    buyButtonSection.remove()
  }
}

function modifyFooterText () {
  const footerSupaduText = document.querySelector('.footer__small-text')
  if (!footerSupaduText) return
  footerSupaduText.innerHTML = '<p class="footer__small-text">Built by <a href="https://www.supadu.com/" target="_blank">Supadu</a></p>'
}

function customFunctions () {
  addAvailabilityCheck()
  hideAudioBooks()
  modifyFooterText()
}

module.exports = { customFunctions }
